/**
 * Image Component
 *
 * Static illustrations from /images (Vite publicDir = static/).
 */

import React from 'react'

const Image = props => {
  if (!props.filename) {
    return null
  }
  return (
    <img
      alt={props.alt || ``}
      className={`image-wrapper`}
      src={`/images/${props.filename}`}
      style={{
        objectFit: props.objectFit || `cover`,
        objectPosition: props.objectPosition || `50% 50%`,
        width: `100%`,
        height: `100%`,
        ...props.style,
      }}
    />
  )
}

export default Image
